<template>
  <button :value="value" @click="$emit('input', !value)" class="container">
    <div class="select-box">
      <div v-show="value">
        <div class="dummy-check"></div>
      </div>
    </div>
    <p>{{ text }}</p>
  </button>
</template>

<script>
export default {
	props:{
		text:String,
		value:Boolean
	},
}
</script>

<style scoped>
.container {
  display: grid;
  grid-template-columns: 2em 1fr 2em;
  justify-content: space-around;
  width: 100%;
  padding: 0.4em 0.4em;
  font-size: 1.3em;
  color: var(--bg-color);
  background-color: var(--main-color);
  border-radius: 2em;
}

.select-box {
  position: relative;
  width: 1.5em;
  height: 1.5em;
  margin-left: auto;
  margin-right: 0;
  border: 2px solid #707070;
  border-radius: 10px;
  background-color: var(--bg-color);
}

.dummy-check {
  position: absolute;
  width: 60%;
  height: 80%;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  border-style: solid;
  border-color: var(--main-color);
  border-left: 1px;
  border-top: 1px;
}
</style>